export default {
	fileName: 'File Name',
	modifiedTime: 'Modified Time',
	fileSize: 'File Size',
	mainDrive: 'Main Drive',
	search: 'Search',
	fileUpload: 'File Upload',
	urlUpload: 'Upload from url',
	upload: 'Upload',
	fileToUpload: 'File to upload',
	uploading: 'Uploading...',
	serverProcessing: 'Server is processing the file now',
	bigFileUploadWarning:
		"Due to CloudFlare Workers' limitation, uploading bigfiles may randomly failed."
}
